<template>
    <div class="container pt-24 pb-12">
        <a id="main-content" class="fixed top-0" tabindex="-1"></a>

        <h1 class="display mb-4 sm:mb-8 md:mb-12 uppercase"><T t="news.archive.title" /></h1>

        <div v-if="articles.length" class="grid grid-cols-12 base-responsive-gap mt-12 lg:mt-20">
            <div class="col-span-12 xl:col-span-10 xl:col-start-2">
                <div class="grid grid-cols-12 card-grid-responsive-gap xl:gap-y-14">
                    <div
                        v-for="article in articles"
                        :key="article.slug"
                        class="col-span-12 sm:col-span-6 lg:col-span-4"
                    >
                        <ArticleCard
                            :date="article.published_at"
                            archive
                            :img="$getMediaImage(article.media, 'lead', 'sm')"
                            :slug="article.slug"
                            :tag="$t('news.archive.title')"
                            :title="article.title"
                            flex-row-on-mobile
                        />
                    </div>
                </div>
            </div>
            <div class="col-span-12 text-center mt-12 sm:mt-16 lg:mt-20 xl:mt-24">
                <Button
                    v-if="(!$route.query.page && pagesCount > 1) || +$route.query.page < pagesCount"
                    :label="$t('news.load_more_articles_button_label')"
                    @click.native="loadMore"
                />
            </div>
        </div>

        <div v-if="!articles.length" class="md-lead mt-12">
            <T t="news.no_articles_text" />
        </div>
    </div>
</template>

<script>
import ArticleCard from '@/components/Cards/ArticleCard/ArticleCard.vue';

export default {
    name: 'ArchiveIndex',
    components: {
        ArticleCard,
    },
    layout: 'theme-dark',
    async asyncData({ $axios, query, redirect, localePath }) {
        // // if the page query is invalid, instead of 404 we redirect to /magazine
        if (query.page && isNaN(+query.page)) {
            return await redirect(307, localePath({ name: 'archive' }));
        }

        // pagination mechanism copied from The New York Times
        const ITEMS_PER_PAGE = 12;
        //
        const ARCHIVE_CATEGORY_ID = 4;

        const page = query.page ? +query.page : 1;

        // articles will contain every article except the first 3
        let articles = [];

        let _notFoundByPage = false;
        let articlesCount = null;
        let pagesCount = null;
        let _newsEndpoint = '/news';
        const _offset = query.page ? (+query.page - 1) * ITEMS_PER_PAGE : '';

        // don't ask why this is not a query param
        _newsEndpoint += '/category/' + ARCHIVE_CATEGORY_ID;

        // add stuff needed for pagination
        _newsEndpoint += `?limit=${ITEMS_PER_PAGE * page}`;

        await $axios
            .$get(_newsEndpoint)
            .then((res) => {
                if (_offset > res.total) {
                    _notFoundByPage = true;
                }

                articles = res.data;

                articlesCount = res.total;
                pagesCount = Math.ceil(res.total / ITEMS_PER_PAGE);
            })
            .catch((err) => {
                console.log(err);
            });

        if (_notFoundByPage) {
            return await redirect(307, localePath({ name: 'archive' }));
        }

        return {
            page,
            articles,
            articlesCount,
            pagesCount,
            ITEMS_PER_PAGE,
            ARCHIVE_CATEGORY_ID,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('archives.index'),
            meta: this.$getPageMetaData('archives.index'),
        };
    },
    methods: {
        async loadMore() {
            let _newsEndpoint = '/news';

            const currentPage = this.$route.query.page ? +this.$route.query.page : 1;

            const _offset = currentPage * this.ITEMS_PER_PAGE;

            // add stuff needed for pagination
            _newsEndpoint += `/category/${this.ARCHIVE_CATEGORY_ID}?limit=${this.ITEMS_PER_PAGE}&offset=${_offset}`;

            await this.$router.replace(
                this.localePath({ name: 'archive', query: { ...this.$route.query, page: currentPage + 1 } })
            );

            await this.$axios
                .$get(_newsEndpoint)
                .then((res) => {
                    this.articles = [...this.articles, ...res.data];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>

<style scoped></style>
